<template>
  <div>
    <router-link :to="{ path: '/'+link }">
        <div class="caption round-medium shadow-huge card left-text" :style="backgroundImg">
            <!-- <div class="caption-overlay bg-gradient" :style="style"></div>
            <div class="caption-top">
                <div v-if="icon!=''">
                    <i :class="icon"></i>
                </div>
            </div>
            <div class="caption-center">
                <div v-if="icon=='fa fa-entre'">
                    <h4 class="color-white ultrabold bottom-10">{{ title }}</h4>
                </div>
                <div v-else>
                    <h4 class="color-white ultrabold bottom-10">{{ title }}</h4>
                </div>
                <p class="color-white card-desc">{{ description }}</p>
            </div> -->
            <img v-bind:src="'images/mpower-new/'+image" class="caption-image owl-lazy">
            <!-- <img v-bind:src="'images/mpower/slider_bg/'+image" class="caption-image owl-lazy"> -->
        </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'SliderAbout',
  props: {
    icon: String,
    title: String,
    description: String,
    color: String,
    image: String,
    link: String,
  },
  computed: {
      style () {
        return {backgroundColor: this.color};
      },
      backgroundImg(){
            return {backgroundImage:'url(\'images/mpower-new/' + this.image + '\')'};
      }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-gradient{
    opacity: 0.8;
    background: none;
}
.card{
    text-align: left;
    /* height: 300px; */
    width: 100%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
.card-desc{
    font-size: 11px;
    line-height: 1.1;
}
.caption-top{
    left: 40px;
    top: 95px;
}
.caption-center{
    left: 40px;
    top: 130px;
    right: 20px;
    transform:none;
}
.fa:after{
    width: 30px;
    height: 30px;
    background-size:30px 30px;
}
.fa-entre:after{
    background-size: 60px 30px;
    width: 60px; 
    height: 30px;
}
h5{
    font-size: 13.3px;
}
@media(max-width: 570px){
    .caption-top{
        left: 20px;
    }
    .caption-center{
        left: 20px;
    }
}
@media(max-width: 350px){
    .caption-center h4{
        font-size: 15px;
        line-height: 1.2;
    }
}
</style>
